const isEnvFlagEnabled = (value?: string) => value?.trim().toLowerCase() === 'true';

export const isMentalHealthEnabled = isEnvFlagEnabled(process.env.REACT_APP_ENABLE_MENTAL_HEALTH);

/** Telegram-бот / ассистент здоровья. При false скрываем все упоминания ТГ в UI. */
export const isTelegramBotEnabled = isEnvFlagEnabled(process.env.REACT_APP_ENABLE_TELEGRAM_BOT);
